export default __webpack_public_path__ + "media/images/solicitors-image-ca9c0ba96ad8e5b10fd4835db73af823.png";